import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import {
  getSysSETDetail, getUserAll,
  postSysSetDetail,
  putSysSetDetail
} from "../../api/apiClient";
import ComboSendTargetFault from "../../components/inputs/ComboSendTargetFault";
import CheckDayOfWeek from "../../components/inputs/CheckDayOfWeek";
import ComboHourPeriod from "../../components/inputs/ComboHourPeriod";
import ComboSeriusLevel from "../../components/inputs/ComboSeriusLevel";
import RadioIsActivate from "../../components/inputs/RadioIsActivate";
import Receiver from "../../components/receiver/Receiver";
import Swal from "sweetalert2";

const SmsShipReg = ({
                      propGroupId = null,
                      hClose
                    }) => {

  const [smsInfo, setSmsInfo] = useState({
    actvty_at: 0,   // 발송활성여부
    rcptn_days: '0000000',    // 수신요일
    rcptn_from_hr: '00',    // 수신시간(from)
    rcptn_to_hr: '01',    // 수신시간(to)
    serius_level: '1',    // 심각도
    trgt_alarm: '0000',    // 발송대상장애
    user_id: '',   // 수신자
    // user_nm: '',   // 수신자명 *API 필요*
  });

  /*  useEffect(() => {
      // jin1024(김혜정)은 전체 목록에 없는 유저로 확인됨

      // console.log(receive);
      // ID가 key, 이름이 value
      const keys = receiveIds;
      const values = receiveNames;

      const result = keys.reduce((acc, curr, idx) => {
        return {...acc, [curr]: values[idx]};
      }, {});
      setReceive(result);
      console.log(result);

    }, [receiveNames]);*/

  const [receiveList, setReceiveList] = useState([]);

  /* 갱신 */
  const updateDetail = () => {
    // console.log(propGroupId);
    if (propGroupId !== null) {
      getSysSETDetail(propGroupId)
          .then((res) => {
                // console.log(res);
                if (res.data.data !== undefined) {
                  // console.log(res.data.data);
                  setSmsInfo(res.data.data);
                  // console.log(res.data.data.user_id.split(','));
                  setReceiveList(res.data.data.user_id.split(','));
                }
              }
          );
    }
  };

  const [stUserList, setUserList] = useState([]);

  const updateUserList = () => {
    /*getUserListAll().then(res => {
      console.log(res.data.data.list);
      const userResList = res.data.data.list;
      let userList = [];
      let userObj = {};
      for (let i = 0; i < userResList.length; i++) {
        userList.push(userResList[i].user_id);
        userObj[userResList[i].user_id] = userResList[i].user_nm;
      }
      console.log(userList);
      // console.log(userObj);
      setUserList(userList);
    });*/
    getUserAll()
        .then(res => {
          // console.log(res.data.data.list);
          setUserList(res.data.data.list);
        });
  };


  const onSubmit = () => {
    // console.log(propGroupId);
    if (smsInfo.actvty_at == null && smsInfo.actvty_at === undefined) {
      Swal.fire(
          '발송 활성 여부는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (smsInfo.rcptn_days === '0000000') {
      Swal.fire(
          '수신 요일은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!smsInfo.rcptn_from_hr) {
      Swal.fire(
          '수신 시간은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!smsInfo.rcptn_to_hr) {
      Swal.fire(
          '수신 시간은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!smsInfo.serius_level) {
      Swal.fire(
          '심각도는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (smsInfo.trgt_alarm === '0000') {
      Swal.fire(
          '발송 대상 장애는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!smsInfo.user_id) {
      console.log(smsInfo.user_id);
      Swal.fire(
          '수신자는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (propGroupId == null) {
      // console.log('post');
      postSysSetDetail(smsInfo)
          .then((res) => {
            let data = res.data;
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
            hClose();
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    } else {
      // console.log('put');
      putSysSetDetail(smsInfo)
          .then((res) => {
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
            hClose();
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }
    hClose();
  };

  useEffect(() => {
    updateUserList();
    updateDetail();
  }, [])

  const onChangeActvtyAt = (e) => {
    setSmsInfo((prev) => {
      return {...prev, actvty_at: parseInt(e.target.value)};
    });
  };

  const onChangeRcptnDays = (e, idx) => {
    let temp = [];
    for (let i = 0; i < 7; i++) {
      if (i === idx) {
        temp[i] = (e.target.checked) ? '1' : '0';
      } else {
        temp[i] = smsInfo.rcptn_days[i];
      }
    }
    setSmsInfo((prev) => {
      return {...prev, rcptn_days: `${temp[0]}${temp[1]}${temp[2]}${temp[3]}${temp[4]}${temp[5]}${temp[6]}`};
    });
  };

  const onChangeRcptnFromHr = (e) => {
    setSmsInfo((prev) => {
      return {...prev, rcptn_from_hr: e.target.value};
    });
  };

  const onChangeRcptnToHr = (e) => {
    setSmsInfo((prev) => {
      return {...prev, rcptn_to_hr: e.target.value};
    });
  };

  const onChangeSeriusLevel = (e) => {
    setSmsInfo((prev) => {
      return {...prev, serius_level: e.target.value};
    });
  };

  const onChangeTrgtAlarm = (e, idx) => {
    let temp = [];
    for (let i = 0; i < 4; i++) {
      if (i === idx) {
        temp[i] = (e.target.checked) ? '1' : '0';
      } else {
        temp[i] = smsInfo.trgt_alarm[i];
      }
    }
    setSmsInfo((prev) => {
      return {...prev, trgt_alarm: `${temp[0]}${temp[1]}${temp[2]}${temp[3]}`};
    });
  };

  const onChangeReceiveUserId = (userList) => {
    const receiveUserList = userList.join();
    console.log(receiveUserList);
    setSmsInfo((prev) => {
      return {...prev, user_id: receiveUserList};
    });
  };

  useEffect(() => {
    // console.log(smsInfo);
    // setReceiveIds(smsInfo.user_id.split(','));
    // setReceiveNames(smsInfo.user_list.split(','));
  }, [smsInfo]);


  return (
      <Container fluid className={"layer p-2"}>
        <Row className={""}>
          <Col className={''}>
            <Row className={'info-container py-2 mx-3'}>
              <Col md={11} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'gateway-register-form py-3'}
                      id={'gatewayRegisterForm'}
                  >
                    <Row className={"justify-content-center"}>
                      <Col md={12}>
                        <Row>
                          <Col md={12}>
                            <Receiver
                                // userList={smsInfo.user_id} // 수신 리스트
                                propReceiveList={receiveList}
                                propUserList={stUserList}
                                propOnChange={onChangeReceiveUserId}
                            />
                          </Col>

                          <Col md={12}>
                            <ComboSendTargetFault
                                propDefaultValue={smsInfo.trgt_alarm}
                                propOnChange={onChangeTrgtAlarm}
                            />
                          </Col>

                          <Col md={12}>
                            <CheckDayOfWeek
                                propDefaultValue={smsInfo.rcptn_days}
                                propOnChange={onChangeRcptnDays}
                            />
                          </Col>

                          <Col md={12}>
                            <ComboHourPeriod
                                propStartHr={smsInfo.rcptn_from_hr}
                                propEndHr={smsInfo.rcptn_to_hr}
                                propOnChangeFrom={onChangeRcptnFromHr}
                                propOnChangeTo={onChangeRcptnToHr}
                            />
                          </Col>

                          <Col md={12}>
                            <ComboSeriusLevel
                                propDefaultValue={smsInfo.serius_level}
                                propOnChange={onChangeSeriusLevel}
                            />
                          </Col>

                          <Col md={12}>
                            <RadioIsActivate
                                propDefaultValue={smsInfo.actvty_at}
                                propOnChange={onChangeActvtyAt}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
            <Row className={"my-3 justify-content-center"}>
              <Col md={2} className={'justify-content-center'}>
                <Button className={'btn save-btn w-100'}
                        onClick={onSubmit}
                >저장</Button>
              </Col>
              <Col md={2} className={'justify-content-center text-end'}>
                <Button className={'btn btn-secondary w-100'} onClick={hClose}>취소</Button>
              </Col>
            </Row>
          </Col>

        </Row>
      </Container>
  );
};

export default SmsShipReg;
